import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { ApiAuthorizationModule } from 'src/api-authorization/api-authorization.module';
import { AuthorizeInterceptor } from 'src/api-authorization/authorize.interceptor';
import {PanelsModule} from "./shared/panels/panels.module";
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import {GlobalContextService} from "./globalcontext.service";

//import {CommonModule, JsonPipe} from "@angular/common";
//import { CPTProjectComponent } from './features/CPT/cptproject/cptproject.component';



@NgModule({
  declarations: [
    AppComponent,

    //CPTProjectComponent,
    //FetchDataComponent
  ],
  imports: [
    BrowserModule.withServerTransition({appId: 'ng-cli-universal'}),
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    ApiAuthorizationModule,
    CoreModule,
    PanelsModule,
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthorizeInterceptor,
      multi: true
    },
    GlobalContextService],
  bootstrap: [AppComponent]
})
export class AppModule {
}
